import type { AvatarConfig } from './avatarTypes';
import { SPRITES_BY_ID } from './avatarData';

interface InfoPanelProps {
  config: AvatarConfig;
}

export default function InfoPanel({ config }: InfoPanelProps) {
  const sprite = SPRITES_BY_ID[config.entityType];
  const categoryLabel = config.entityCategory.charAt(0).toUpperCase() + config.entityCategory.slice(1);

  return (
    <div className="malpedia-avatar-info">
      <div className="malpedia-avatar-info-title">Info</div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Type</span>
        <span className="malpedia-avatar-info-value">{sprite?.name ?? config.entityType}</span>
      </div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Category</span>
        <span className="malpedia-avatar-info-value">{categoryLabel}</span>
      </div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Grid</span>
        <span className="malpedia-avatar-info-value">{config.gridSize}x{config.gridSize}</span>
      </div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Eyes</span>
        <span className="malpedia-avatar-info-value">{config.eyes}</span>
      </div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Mouth</span>
        <span className="malpedia-avatar-info-value">{config.mouth}</span>
      </div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Accessory</span>
        <span className="malpedia-avatar-info-value">{config.accessory}</span>
      </div>
      <div className="malpedia-avatar-info-row">
        <span className="malpedia-avatar-info-label">Palette</span>
        <div className="malpedia-avatar-info-palette">
          {Object.values(config.palette).map((c, i) => (
            <span
              key={i}
              className="malpedia-avatar-info-dot"
              style={{ backgroundColor: c }}
              title={c}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
